import { EventAnalyticsTicketScansByTierDto } from 'legacy/events/types';

import { useQuery } from 'react-query';
import { ErrorResponse } from 'legacy/common/utils/error';
import { getEventAnalyticsTicketScansByTier } from '../service';

export function useGetEventAnalyticsTicketScanByTier({
  eventId
}: {
  eventId: string;
}) {
  return useQuery<EventAnalyticsTicketScansByTierDto, ErrorResponse>(
    ['data/ticketScansByTier', { eventId }],
    () => getEventAnalyticsTicketScansByTier({ eventId }),
    { retry: 0, enabled: !!eventId }
  );
}
